import { render, staticRenderFns } from "./IosSafari.vue?vue&type=template&id=c6e1bc92&scoped=true&"
var script = {}
import style0 from "./IosSafari.vue?vue&type=style&index=0&id=c6e1bc92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e1bc92",
  null
  
)

export default component.exports